import { Injectable } from '@angular/core';
import { ConfigurationsService } from '@epicuro-next/platform/configuration';
import {
  presetFilterId,
  toggleFilter,
} from '@epicuro-next/state/p-basket-state';
import {
  selectAccountId,
  selectSiteId,
} from '@epicuro-next/state/session-state';
import {
  selectUser,
  uploadAvatarImageSuccess,
} from '@epicuro-next/state/user-state';
import { isEqual, isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  mapTo,
  switchMap,
} from 'rxjs/operators';

import {
  NAMESPACE_NEWS_FEED,
  NewsfeedConfigurationKeys,
  NewsfeedConfigurations,
} from '../../configuration';
import { updateCurrentUserImage } from '../actions';
import * as actions from '../actions';

/** News feed reset effects */
@Injectable()
export class ResetEffects {
  public reset$ = createEffect(() =>
    combineLatest([
      this.store.pipe(select(selectSiteId), filter(isNonNullish)),
      this.store.pipe(select(selectAccountId), filter(isNonNullish)),
    ]).pipe(
      distinctUntilChanged(isEqual),
      map(() => actions.reset()),
    ),
  );

  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.reset),
      map(() => actions.fetch()),
    ),
  );

  public fetchOnTogglePreset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(toggleFilter),
      filter((action) => action.fieldId === presetFilterId),
      switchMap(() =>
        this.configuration.getConfigValue<
          NewsfeedConfigurations,
          NewsfeedConfigurationKeys.includePresetsInFiltering
        >({
          namespace: NAMESPACE_NEWS_FEED,
          featureName: NewsfeedConfigurationKeys.includePresetsInFiltering,
          defaultValue: false,
        }),
      ),
      filter(Boolean),
      mapTo(actions.reset()),
    ),
  );

  public updateCurrentUserImageOnUploadAvatarImageSucces$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uploadAvatarImageSuccess),
      concatLatestFrom(() => this.store.pipe(select(selectUser))),
      filter(([_, user]) => isNonNullish(user)),
      map(([{ url }, user]) =>
        updateCurrentUserImage({
          userId: user?.externalId ?? '',
          url,
        }),
      ),
    ),
  );

  /** Dependencies */
  constructor(
    private store: Store,
    private actions$: Actions,
    private configuration: ConfigurationsService,
  ) {}
}
